import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { RowStatusMarkComponent } from '@modules/team-list-state/row-status-mark.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CanPurgePipe } from '@modules/common/pipes/can-purge.pipe';
import { CommentsModule } from '@modules/comments/comments.module';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { SearchLocationBadgeComponent } from '@frontendlib/components/components/search-location-badge/search-location-badge.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { RailMenuComponent } from '@modules/common/components/rail-menu/rail-menu.component';
import { RailSkeletonComponent } from '@modules/common/components/rail-skeleton/rail-skeleton.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { NotebookQuickFormComponent } from '@modules/elements/components/quick-forms/notebook-quick-form/notebook-quick-form.component';
import { QuickFormComponent } from '@modules/elements/components/quick-forms/quick-form/quick-form.component';
import { NoteContextMenuDirective } from '@modules/elements/directives/note-context-menu.directive';
import { NotebookContextMenuDirective } from '@modules/elements/directives/notebook-context-menu.directive';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { MatIconModule } from '@angular/material/icon';
import { KnotsModule } from '@modules/knots/knots.module';
import { SideBarNotebooksComponent } from '@modules/notes/components/side-bar-notebooks/side-bar-notebooks.component';
import { SidebarContextMenuComponent } from '@modules/notes/components/sidebar-context-menu/sidebar-context-menu.component';
import { SidebarContextMenuDirective } from '@modules/notes/directives/sidebar-context-menu.directive';
import { TitleByNotesFilterPipe } from '@modules/notes/pipes/title-by-notes-filter.pipe';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { TagsModule } from '@modules/tags/tags.module';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { EditorModule } from '@hugerte/hugerte-angular';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { ElementsModule } from '../elements/elements.module';
import { NoteFormComponent } from './components/note-form/note-form.component';
import { NotebookFormComponent } from './components/notebook-form/notebook-form.component';
import { TenancySelectorComponent } from '@modules/common/components/tenancy-selector/tenancy-selector.component';
import { NotebookSectionsComponent } from './components/notebook-sections/notebook-sections.component';
import { NotebooksListContextMenuComponent } from './components/notebooks-list-context-menu/notebooks-list-context-menu.component';
import { NotebooksListComponent } from './components/notebooks-list/notebooks-list.component';
import { NotesListContainerComponent } from './components/notes-list-container/notes-list-container.component';
import { NotesListContextMenuComponent } from './components/notes-list-context-menu/notes-list-context-menu.component';
import { NotesListComponent } from './components/notes-list/notes-list.component';
import { NotesMainViewComponent } from './components/notes-main-view/notes-main-view.component';
import { SideBarNotebooksTreeComponent } from './components/side-bar-notebooks-tree/side-bar-notebooks-tree.component';
import { NotesSideBarComponent } from './components/side-bar/side-bar.component';
import { NotebooksListContextMenuDirective } from './directives/notebooks-list-context-menu.directive';
import { NotesListContextMenuDirective } from './directives/notes-list-context-menu.directive';
import { NotesPermissionDirective } from './directives/notes-permission.directive';
import { NotesPermissionPipe } from './pipes/notes-permission.pipe';
import { NoteAssignedListComponent } from './collaboration/note-assigned-list.component';

@NgModule({
  imports: [
    DetailBreadcrumbsComponent,
    RowStatusMarkComponent,
    RailMenuComponent,
    RailSkeletonComponent,
    TenancySelectorComponent,
    SearchLocationBadgeComponent,
    AppCommonModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    EditorModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    CanPurgePipe,
    ContextMenuDividerComponent, ContextMenuHeadingComponent, ContextMenuItemComponent, ContextMenuStateIndicatorComponent, PopoverDirective,
    ReactiveFormsModule,
    ScrollModule,
    ScrollingModule,
    TagsModule,
    UtilsModule,
    ListLoadErrorComponent,
    NoContentStubComponent,
    LoadingIndicatorComponent,
    ListItemSeparatorComponent,
    ListSelectionBarComponent,
    Pagination2Component,
    QuickActionComponent,
    ItemDescriptionFieldComponent,
    NotesPermissionPipe,
    NotesPermissionDirective,
    ToArrayPipe,
    NotebookContextMenuDirective,
    NoteContextMenuDirective,
    LinkedInfoListComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    QuickFormComponent,
    NotebookQuickFormComponent,
    SidebarItemComponent,
    NoteFormComponent,
    Button2Component,
    IconComponent,
    StitchTimestampsComponent,
  ],
  declarations: [
    // Components
    NotebookFormComponent,
    NotebookSectionsComponent,
    NotebooksListComponent,
    NotebooksListContextMenuComponent,
    NotesListComponent,
    NotesListContainerComponent,
    NotesListContextMenuComponent,
    NotesMainViewComponent,
    NotesSideBarComponent,
    NoteAssignedListComponent,
    SideBarNotebooksComponent,
    SideBarNotebooksTreeComponent,
    SidebarContextMenuComponent,
    // Directives
    NotebooksListContextMenuDirective,
    NotesListContextMenuDirective,
    // Pipes
    TitleByNotesFilterPipe,
    SidebarContextMenuDirective,
  ],
  exports: [
    // Components
    NoteFormComponent,
    NotebookFormComponent,
    NotebooksListComponent,
    NotesListComponent,
    NotesListContainerComponent,
    NotesMainViewComponent,
    NotesSideBarComponent,
    // Directives
    NotebooksListContextMenuDirective,
    NotesListContextMenuDirective,
    // Pipes
    TitleByNotesFilterPipe,
  ],
  providers: [],
})
export class NotesModule {}
